export default __webpack_public_path__ + "static/MARKER BOARD-ae4ab3ffbb32911e234241eca798348e.webp";